import { render, staticRenderFns } from "./widget.component.vue?vue&type=template&id=23044ab0&scoped=true"
import script from "./widget.component.vue?vue&type=script&lang=ts"
export * from "./widget.component.vue?vue&type=script&lang=ts"
import style0 from "./widget.component.vue?vue&type=style&index=0&id=23044ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23044ab0",
  null
  
)

export default component.exports